module.exports = __webpack_public_path__ + "static/img/HY-S1-II-chair.8e9254ea.png";